<template>
  <v-container pr-3>
    <v-layout column>
      <v-flex>
        <filters-bar
          title="Validación de nombre de clientes"
          title-class="headline"
          btnFilterSize="md3"
          :date="false"
          :has-date-type="false"
          :filters="filters"
          :custom-filters="customFilters"
          @search="search">
        </filters-bar>
      </v-flex>
      <v-flex>
        <v-card>
          <v-card-text>
            <template v-if="isLoading">
              <v-layout style="height:215px" text-xs-center align-center>
                <v-flex>
                  <v-icon x-large>
                    fas fa-spinner fa-pulse
                  </v-icon>
                  <p>
                    Cargando
                  </p>
                </v-flex>
              </v-layout>
            </template>
            <template v-else>
              <template v-if="customers.length > 0">
                <v-layout row wrap>
                  <v-flex>
                    <p class="display-2">
                      {{name || `${customer.firts_name} ${customer.last_name}` || 'No posee'}}
                    </p>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-end>
                  <v-flex class="text-xs-right" md2 v-if="customer.fiscal_id">
                    <p class="caption">
                      RUT: {{customer.fiscal_id}}
                    </p>
                  </v-flex>
                  <v-flex class="text-xs-right" md2 v-if="customer.account">
                    <p class="caption">
                      Cuenta: {{customer.account}}
                    </p>
                  </v-flex>
                </v-layout> 
                <v-layout align-center row wrap data-app>
                  <v-flex md6 pr-5>
                    <v-layout row wrap>
                      <v-select
                        v-model="customer.first_name"
                        @input="hide('first_name')"
                        ref="first_name"
                        :items="items"
                        label="Primer Nombre"
                        multiple
                        clearable
                        deletable-chips
                        tags
                        chips
                        color="black"
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex md6 pl-5>
                    <v-layout row wrap>
                      <v-select
                        v-model="customer.last_name"
                        @input="hide('last_name')"
                        ref="last_name"
                        :items="items"
                        label="Primer Apellido"
                        multiple
                        clearable
                        deletable-chips
                        tags
                        chips
                        color="black"
                      />
                    </v-layout>
                    <v-layout row wrap>
                    </v-layout>
                  </v-flex>
                  <v-checkbox 
                    label="Cambiar nombre completo"
                    :false-value="0"
                    :true-value="1"
                    v-model="saveName" >
                  </v-checkbox>
                </v-layout>
              </template>
              <template v-else>
                <v-layout row wrap class="mt-2 mb-2">
                  <v-flex xs12 text-xs-center>
                  <span class="display-1">
                    No se encontraron clientes
                  </span>
                  </v-flex>
                </v-layout>
              </template>
            </template>
          </v-card-text>
          <v-card-actions class="mt-5" v-if="!isLoading">
            <v-flex class="text-xs-left xs12">
              <p class="caption">
                Nombres faltantes: {{count}}
              </p>
            </v-flex>
            <v-flex class="text-xs-right xs12" pr-4>
              <v-btn flat @click="next" color="info">
                SALTAR
              </v-btn>
              <v-btn class="k-orange-linear-text" flat @click="save" :disabled="errors.any()">
                SIGUIENTE
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import _ from 'lodash';
import FiltersBar from '@/components/global/FiltersBar';

export default {
  inject: ['$validator'],
  components: {
    FiltersBar,
  },
  mounted() {
    this.search();
  },
  data() {
    return {
      count: 0,
      filters: {},
      customers: [],
      saveName: false,
      isLoading: true,
      saveCustomers: [],
      customFilters: [
        {
          text: 'Estado',
          value: 'customer_status',
        },
        {
          text: 'Etapa de la gestión',
          value: 'ns_stage_id',
        },
        {
          text: 'Estado del tramo',
          value: 'trancheStatus',
        },
        {
          text: 'Ultimo canal de gestión',
          value: 'last_n_channel_id',
        },
        {
          text: 'Ultimo canal de contacto',
          value: 'last_r_channel_id',
        },
        {
          text: 'Ultimo canal de contacto util',
          value: 'last_c_channel_id',
        },
        {
          text: 'Nombre',
          value: 'first_name',
        },
        {
          text: 'Apellido',
          value: 'last_name',
        },
      ],
    };
  },
  beforeDestroy() {
    this.sendSave();
  },
  computed: {
    customer() {
      return this.customers[0] || {};
    },
    name() {
      return this.customer.name;
    },
    items() {
      const except = (this.customer.first_name || []).concat((this.customer.last_name || []));
      const items = _.split(this.name || '', ' ');
      return _.chain(items)
        .filter(x => x && !except.includes(x))
        .value();
    },
  },
  methods: {
    hide(type) {
      setTimeout(() => {
        this.$refs[type].menuIsActive = false;
      }, 100);
    },
    search(event = null) {
      if (event) {
        this.filters = {
          ...this.filters,
          ...event,
        };
      }
      this.isLoading = true;
      this.axios.get('customers_validate/name', {
        params: {
          ...this.filters,
        },
      }).then(({ data }) => {
        const customers = _.map(data.customers, x => ({
          ...x,
          first_name: _.filter((x.first_name || '').split(' ')),
          last_name: _.filter((x.last_name || '').split(' ')),
        }));
        this.customers = customers;
        this.count = parseInt(data.count, 10);
        this.isLoading = false;
      });
    },
    next() {
      this.count -= 1;
      this.saveName = false;
      if ((this.customers.length - 1) < 1) {
        this.search();
      }
      this.customers.shift();
    },
    sendSave() {
      this.axios.patch('customers_validate/name', {
        customers: this.saveCustomers,
      });
      this.saveCustomers = [];
    },
    save() {
      const obj = {
        ...this.customer,
        first_name: (this.customer.first_name || []).join(' '),
        last_name: (this.customer.last_name || []).join(' '),
      };
      if (this.saveName) {
        obj.name = `${this.customer.first_name} ${this.customer.last_name}`;
      }
      this.saveCustomers.push(obj);
      this.next();
    },
  },
  watch: {
    saveCustomers: {
      deep: true,
      handler(val) {
        if (val.length === 10) {
          this.sendSave();
        }
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/customer/validateNames/Index.vue